import React from 'react';
import { Download, FileText, Award } from 'lucide-react';
import { documentsData } from '../mock/mockData';

const Downloads = () => {
  const categorizedDocs = {
    'Presentazione Aziendale': documentsData.filter((d) => d.category === 'Presentazione Aziendale'),
    'Certificazioni': documentsData.filter((d) => d.category === 'Certificazioni'),
    'Documenti Finanziari': documentsData.filter((d) => d.category === 'Documenti Finanziari'),
    'Governance': documentsData.filter((d) => d.category === 'Governance')
  };

  const getIcon = (category) => {
    switch (category) {
      case 'Presentazione Aziendale':
        return FileText;
      case 'Certificazioni':
        return Award;
      case 'Documenti Finanziari':
        return FileText;
      case 'Governance':
        return FileText;
      default:
        return FileText;
    }
  };

  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="relative py-32 bg-gradient-to-br from-[#081221] to-[#0d63ce]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 text-center">
          <h1 className="font-serif text-6xl md:text-7xl font-bold text-white mb-6">
            Download Center
          </h1>
          <p className="text-2xl text-white/90 max-w-4xl mx-auto leading-relaxed">
            Accedi alla documentazione aziendale, certificazioni e report finanziari
          </p>
        </div>
      </section>

      {/* Documents by Category */}
      <section className="py-24 bg-[#f5f7fb]">
        <div className="max-w-7xl mx-auto px-6 lg:px-8 space-y-16">
          {Object.entries(categorizedDocs).map(([category, docs]) => {
            const IconComponent = getIcon(category);
            return (
              <div key={category}>
                <div className="flex items-center space-x-4 mb-8">
                  <div className="w-12 h-12 bg-gradient-to-br from-[#0d63ce] to-[#18a06b] rounded-lg flex items-center justify-center">
                    <IconComponent className="text-white" size={24} />
                  </div>
                  <h2 className="font-serif text-4xl font-bold text-[#081221]">{category}</h2>
                </div>

                <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
                  {docs.map((doc) => (
                    <a
                      key={doc.id}
                      href={doc.url || '#'}
                      target="_blank"
                      rel="noopener noreferrer"
                      download
                      className="flex items-center justify-between p-6 bg-white rounded-xl shadow-lg hover:shadow-2xl transition-all transform hover:-translate-y-1 text-left"
                    >
                      <div className="flex items-center space-x-4 flex-grow">
                        <div className="w-16 h-16 bg-gradient-to-br from-[#0d63ce]/10 to-[#18a06b]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                          <FileText className="text-[#0d63ce]" size={28} />
                        </div>
                        <div>
                          <h3 className="font-semibold text-[#081221] text-lg mb-1">
                            {doc.title}
                          </h3>
                          <div className="flex items-center space-x-3 text-sm text-gray-500">
                            <span className="px-2 py-1 bg-gray-100 rounded">{doc.format}</span>
                            <span>{doc.size}</span>
                          </div>
                        </div>
                      </div>
                      <div className="w-12 h-12 bg-[#0d63ce] hover:bg-[#081221] rounded-lg flex items-center justify-center flex-shrink-0 ml-4 transition-colors">
                        <Download className="text-white" size={20} />
                      </div>
                    </a>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </section>

      {/* Contact for More Info */}
      <section className="py-24 bg-[#081221] text-white">
        <div className="max-w-4xl mx-auto px-6 lg:px-8 text-center">
          <h2 className="font-serif text-5xl font-bold mb-6">Hai Bisogno di Altri Documenti?</h2>
          <p className="text-xl text-white/80 leading-relaxed mb-8">
            Per richiedere documentazione aggiuntiva o informazioni specifiche, contatta il nostro
            team.
          </p>
          <button className="px-8 py-4 bg-white text-[#081221] rounded-lg font-semibold hover:bg-gray-100 transition-colors">
            Contattaci
          </button>
        </div>
      </section>
    </div>
  );
};

export default Downloads;
